export const STATE_MAIN_NAVIGATION = 'mainNavigation';

export const LOCAL_STORE_IS_LEFT_MENU_PINNED_CLOSED = '@MainNavigation/IS_LEFT_MENU_PINNED_CLOSED';

export const ACTION_ACTIVATE_LEFT_MENU_SECTION = '@MainNavigation/ACTION_ACTIVATE_LEFT_MENU_SECTION';
export const ACTION_ON_MENU_SPEC_FETCH_ERROR = '@MainNavigation/ACTION_ON_MENU_SPEC_FETCH_ERROR';
export const ACTION_ON_MENU_SPEC_FETCH_SUCCESS = '@MainNavigation/ACTION_ON_MENU_SPEC_FETCH_SUCCESS';
export const ACTION_UPDATE_DEBUG_INFO_DATA_STATE = '@MainNavigation/ACTION_UPDATE_DEBUG_INFO_DATA_STATE';
export const ACTION_UPDATE_DEBUG_INFO_OPEN_STATE = '@MainNavigation/ACTION_UPDATE_DEBUG_INFO_OPEN_STATE';
export const ACTION_UPDATE_SIDE_MENU_OPEN_STATE = '@MainNavigation/ACTION_UPDATE_SIDE_MENU_OPEN_STATE';
export const ACTION_UPDATE_SIDE_MENU_PINNED_OPEN_STATE = '@MainNavigation/ACTION_UPDATE_SIDE_MENU_PINNED_OPEN_STATE';
export const ACTION_UPDATE_SIDE_MENU_TIME_STAMP_STATE = '@MainNavigation/ACTION_UPDATE_SIDE_MENU_TIME_STAMP_STATE';
export const ACTION_UPDATE_SIDE_OPEN_SECTION_ID = '@MainNavigation/ACTION_UPDATE_SIDE_OPEN_SECTION_ID';
